document.getElementById('buttonMenu').addEventListener('click', function(event) {
    event.preventDefault();

    document.body.classList.add('open_modal');

    document.getElementById('mainModalContent').style.display = 'block';
    document.getElementById('modalContentConf').style.display = 'none';
    document.getElementById('mainSearchModal').style.display = 'none';

    var overlay = document.getElementById('overlay');
    var openModalMenu = document.getElementById('openModalMenu');
    var modalIconClose = document.getElementById('modalIconClose');

    if (document.body.classList.contains('animateOff')) {
        overlay.style.display = 'block';
        openModalMenu.style.display = 'block';
        openModalMenu.style.opacity = '1';
        modalIconClose.focus();
    } else {
        fadeIn(overlay, 400, function() {
            openModalMenu.style.display = 'block';
            fadeIn(openModalMenu, 200, function() {
                openModalMenu.style.opacity = '1';
                modalIconClose.focus();
            });
        });
    }
});

function fadeIn(element, duration, callback) {
    var op = 0.1;  // initial opacity
    element.style.display = 'block';
    var timer = setInterval(function() {
        if (op >= 1){
            clearInterval(timer);
            if (callback) callback();
        }
        element.style.opacity = op;
        op += op * 0.1;
    }, duration / 50);
}